export function checkOuroboros(baseArr, dragId, dropId, parentIdArr) {
  // console.log(baseArr)
  // console.log("DRAG_ID", dragId)
  // console.log("DROP_ID", dropId)

  if(dragId === dropId) {
    return true
  }

  // Recurively check
  for(let item of baseArr) {
    if(parentIdArr.includes(item.id)) {
      return true
    }
    if(item.filterType !== 'filter') {
      let updateBaseArray = [item.id]
      updateBaseArray = updateBaseArray.concat(parentIdArr)
      if(checkOuroboros(item.filters, dragId, dropId, updateBaseArray)) {
        return true
      }
    }
  }

  return false
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/checkOuroboros.js